module.exports = "/_next/static/images/macpunks-3-c5a5854132ed0641917231d161290cfa.png";